<template>
    <div class="inline">
        <el-form-item :class="{'is-error':error}" class="date-time-item">
        <div v-if="column.dateType==dateType.time">
            <!--时间选择器 可配置间隔-->
            <el-time-select v-model="start" :picker-options="{start: '08:30',step: '00:15',end: '18:30'}" placeholder="选择开始时间"></el-time-select>
            <span class="center-txt">至</span>
            <el-time-select v-model="end" :picker-options="{start: '08:30',step: '00:15',end: '18:30'}" placeholder="选择结束时间"></el-time-select>
        </div>
        <div v-else-if="column.dateType==dateType.date">
            <!--日期选择器-->
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="start" type="date" placeholder="选择开始日期" :clearable="true"></el-date-picker>
            <span class="center-txt">至</span>
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="end" type="date" placeholder="选择结束日期" :clearable="true"></el-date-picker>
        </div>
        <div v-else-if="column.dateType==dateType.datetime">
            <!--日期时间选择器-->
            <el-date-picker type="datetime" :format="column.format || 'yyyy-MM-dd HH:mm:ss'" value-format="yyyy-MM-dd HH:mm:ss" v-model="start" placeholder="选择开始日期时间" :default-time="column.startDefaultTime||'00:00:00'"></el-date-picker>
            <span class="center-txt">至</span>
            <el-date-picker type="datetime" :format="column.format || 'yyyy-MM-dd HH:mm:ss'" value-format="yyyy-MM-dd HH:mm:ss" v-model="end" placeholder="选择结束日期时间" :default-time="column.endDefaultTime||'23:59:59'"></el-date-picker>
        </div>
        <div v-show="error" class="el-form-item__error">开始时间必须小于结束时间</div>
        </el-form-item>
    </div>
</template>
<script>
export default {
    props:['column'],
    data(){
        return {
            error:false,
            start:'',
            end:'',
            dateType:{time:'time',date:'date',datetime:'datetime'}
        }
    },
    watch:{
        start(){
          this.timeCompare();
        },
        end(){
          this.timeCompare();
        }
    },
  mounted() {
      console.log(this.column)
  },
  methods:{
        setValue(start, end){
            this.start = start;
            this.end = end;
        },
        clearData(){
            this.start='';
            this.end='';
        },
        timeCompare(){
            if(this.start&&this.end&&this.start>this.end){
                this.error = true;
            }else{
                this.error = false;
                this.$emit('dateChange',(this.start||'')+(this.end?(','+this.end):''))
            }

        },
        getFormData(){
            if(this.error) return false;
            else return (this.start||'')+(this.end?(','+this.end):'');
        }
    }
}
</script>
<style>
.date-time-item{
    line-height: 30px;
}
.center-txt {
    margin:0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/dateTimeRange.vue